import { ClientType, HostMessage, HostMessageType, HostPresence, PresenceMessage, PresenceMessageType, type HostMacroRecordingUploadCompletePayload } from '@playcastdotio/Messaging';
import { remoteHostList } from '../../../stores/shared';

type RemoteHost = (typeof remoteHostList)['currentState']['hosts']['uniqueId'];

type MacroRecordingUploadCompleteMessage = Extract<
  HostMessage,
  { type: HostMessageType.HOST_MACRO_RECORDING_UPLOAD_COMPLETE }
>;

export function isMacroRecordingUploadCompleteMessage(
  message: HostMessage,
): message is MacroRecordingUploadCompleteMessage {
  return message.type === HostMessageType.HOST_MACRO_RECORDING_UPLOAD_COMPLETE;
}

export function handleMacroRecordingUploadCompleteMessage(message: HostMessage): void {
  if (!isMacroRecordingUploadCompleteMessage(message)) {
    return;
  }

  const payload: HostMacroRecordingUploadCompletePayload = message.success
    ? {
        requestId: message.requestId,
        takeId: message.takeId,
        success: true,
        sizeBytes: message.sizeBytes,
      }
    : {
        requestId: message.requestId,
        takeId: message.takeId,
        success: false,
        error: message.error,
      };

  console.log('Macro recording upload complete ingress', {
    requestId: payload.requestId,
    takeId: payload.takeId,
    success: payload.success,
    sizeBytes: payload.success ? payload.sizeBytes : undefined,
    error: payload.success ? undefined : payload.error,
  });
}

export const handlePresenceMessage = (message: PresenceMessage) => {
  console.log('Presence message:', message);

  switch (message.type) {
    case PresenceMessageType.PRESENCE_CHANGED: {
      if (message.clientType !== ClientType.HOST) return;

      const machineId = message.clientId;
      const active = remoteHostList.currentState.hosts[machineId];
      const inactive = remoteHostList.currentState.inactive[machineId];

      const presence = message.presence as HostPresence;
      const remoteHostObj: RemoteHost = {
        remoteId: presence.remoteHostPeerId ?? '',
        uniqueId: machineId,
        displayName: active?.displayName ?? inactive?.displayName ?? '',
        machineId: machineId,
        environment: 'test',
        version: '1.0.0',
        joinedCount: presence.playerCount ?? 0,
        pendingCount: -1,
      };

      delete remoteHostList.currentState.inactive[machineId];
      delete remoteHostList.currentState.hosts[machineId];

      const isOffline = presence.status === 'offline';
      if (isOffline) {
        remoteHostList.currentState.inactive[machineId] = remoteHostObj;
      } else {
        remoteHostList.currentState.hosts[machineId] = remoteHostObj;
      }

      remoteHostList.updateState({
        ...remoteHostList.currentState,
        inactive: { ...remoteHostList.currentState.inactive },
        hosts: { ...remoteHostList.currentState.hosts },
      });
      break;
    }
  }
};

